import type { LcIconName } from '@lottocom/frontend-components'

export const REGISTER_FORM_ACCOUNT = {
  Email: 'email',
  Password: 'password',
  PasswordConfirm: 'passwordConfirm',
} as const

export const REGISTER_FORM_ADDRESS = {
  Additionalinfo: 'additionalInfo',
  Autocomplete: 'google-address-autocomplete',
  City: 'city',
  Country: 'country',
  State: 'state',
  StateLong: 'stateLong',
  StreetName: 'streetName',
  StreetNumber: 'streetNumber',
  Zipcode: 'zipCode',
} as const

export const REGISTER_FORM_ADDRESS_COUNTRIES_UNITED_STATES = 'United States' as const

export const REGISTER_FORM_ADDRESS_COUNTRIES_PUERTO_RICO = 'Puerto Rico' as const

const REGISTER_FORM_ADDRESS_COUNTRIES_MOST_USED = [
  {
    label: 'register.step.address.country.unitedstates',
    value: 'United States',
  },
  {
    label: 'register.step.address.country.canada',
    value: 'Canada',
  },
  {
    label: 'register.step.address.country.mexico',
    value: 'Mexico',
  },
  {
    label: 'licensedterritory.uspr',
    value: 'Puerto Rico',
  },
]

const REGISTER_FORM_ADDRESS_COUNTRIES = [
  {
    label: 'register.step.address.country.afghanistan',
    value: 'Afghanistan',
  },
  {
    label: 'register.step.address.country.albania',
    value: 'Albania',
  },
  {
    label: 'register.step.address.country.algeria',
    value: 'Algeria',
  },
  {
    label: 'register.step.address.country.andorra',
    value: 'Andorra',
  },
  {
    label: 'register.step.address.country.angola',
    value: 'Angola',
  },
  {
    label: 'register.step.address.country.anguilla',
    value: 'Anguilla',
  },
  {
    label: 'register.step.address.country.antiguaandbarbuda',
    value: 'Antigua and Barbuda',
  },
  {
    label: 'register.step.address.country.argentina',
    value: 'Argentina',
  },
  {
    label: 'register.step.address.country.armenia',
    value: 'Armenia',
  },
  {
    label: 'register.step.address.country.aruba',
    value: 'Aruba',
  },
  {
    label: 'register.step.address.country.australia',
    value: 'Australia',
  },
  {
    label: 'register.step.address.country.austria',
    value: 'Austria',
  },
  {
    label: 'register.step.address.country.azerbaijan',
    value: 'Azerbaijan',
  },
  {
    label: 'register.step.address.country.bahamas',
    value: 'Bahamas',
  },
  {
    label: 'register.step.address.country.bahrain',
    value: 'Bahrain',
  },
  {
    label: 'register.step.address.country.bangladesh',
    value: 'Bangladesh',
  },
  {
    label: 'register.step.address.country.barbados',
    value: 'Barbados',
  },
  {
    label: 'register.step.address.country.belarus',
    value: 'Belarus',
  },
  {
    label: 'register.step.address.country.belgium',
    value: 'Belgium',
  },
  {
    label: 'register.step.address.country.belize',
    value: 'Belize',
  },
  {
    label: 'register.step.address.country.benin',
    value: 'Benin',
  },
  {
    label: 'register.step.address.country.bermuda',
    value: 'Bermuda',
  },
  {
    label: 'register.step.address.country.bhutan',
    value: 'Bhutan',
  },
  {
    label: 'register.step.address.country.bolivia',
    value: 'Bolivia',
  },
  {
    label: 'register.step.address.country.bosniaandherzegovina',
    value: 'Bosnia and Herzegovina',
  },
  {
    label: 'register.step.address.country.botswana',
    value: 'Botswana',
  },
  {
    label: 'register.step.address.country.brazil',
    value: 'Brazil',
  },
  {
    label: 'register.step.address.country.brunei',
    value: 'Brunei',
  },
  {
    label: 'register.step.address.country.bulgaria',
    value: 'Bulgaria',
  },
  {
    label: 'register.step.address.country.burkinafaso',
    value: 'Burkina Faso',
  },
  {
    label: 'register.step.address.country.burundi',
    value: 'Burundi',
  },
  {
    label: 'register.step.address.country.caboverde',
    value: 'Cabo Verde',
  },
  {
    label: 'register.step.address.country.cambodia',
    value: 'Cambodia',
  },
  {
    label: 'register.step.address.country.cameroon',
    value: 'Cameroon',
  },
  {
    label: 'register.step.address.country.caribbeannetherlands',
    value: 'Caribbean Netherlands',
  },
  {
    label: 'register.step.address.country.caymanislands',
    value: 'Cayman Islands',
  },
  {
    label: 'register.step.address.country.centralafricanrepublic',
    value: 'Central African Republic',
  },
  {
    label: 'register.step.address.country.chad',
    value: 'Chad',
  },
  {
    label: 'register.step.address.country.chile',
    value: 'Chile',
  },
  {
    label: 'register.step.address.country.china',
    value: 'China',
  },
  {
    label: 'register.step.address.country.colombia',
    value: 'Colombia',
  },
  {
    label: 'register.step.address.country.comoros',
    value: 'Comoros',
  },
  {
    label: 'register.step.address.country.congo',
    value: 'Congo',
  },
  {
    label: 'register.step.address.country.congodrc',
    value: 'Congo (DRC)',
  },
  {
    label: 'register.step.address.country.cookislands',
    value: 'Cook Islands',
  },
  {
    label: 'register.step.address.country.costarica',
    value: 'Costa Rica',
  },
  {
    label: 'register.step.address.country.cotedivoire',
    value: 'Côte d’Ivoire',
  },
  {
    label: 'register.step.address.country.croatia',
    value: 'Croatia',
  },
  {
    label: 'register.step.address.country.cuba',
    value: 'Cuba',
  },
  {
    label: 'register.step.address.country.curacao',
    value: 'Curaçao',
  },
  {
    label: 'register.step.address.country.cyprus',
    value: 'Cyprus',
  },
  {
    label: 'register.step.address.country.czechia',
    value: 'Czechia',
  },
  {
    label: 'register.step.address.country.denmark',
    value: 'Denmark',
  },
  {
    label: 'register.step.address.country.djibouti',
    value: 'Djibouti',
  },
  {
    label: 'register.step.address.country.dominica',
    value: 'Dominica',
  },
  {
    label: 'register.step.address.country.dominicanrepublic',
    value: 'Dominican Republic',
  },
  {
    label: 'register.step.address.country.ecuador',
    value: 'Ecuador',
  },
  {
    label: 'register.step.address.country.egypt',
    value: 'Egypt',
  },
  {
    label: 'register.step.address.country.elsalvador',
    value: 'El Salvador',
  },
  {
    label: 'register.step.address.country.equatorialguinea',
    value: 'Equatorial Guinea',
  },
  {
    label: 'register.step.address.country.eritrea',
    value: 'Eritrea',
  },
  {
    label: 'register.step.address.country.estonia',
    value: 'Estonia',
  },
  {
    label: 'register.step.address.country.eswatini',
    value: 'Eswatini',
  },
  {
    label: 'register.step.address.country.ethiopia',
    value: 'Ethiopia',
  },
  {
    label: 'register.step.address.country.faroeislands',
    value: 'Faroe Islands',
  },
  {
    label: 'register.step.address.country.fiji',
    value: 'Fiji',
  },
  {
    label: 'register.step.address.country.finland',
    value: 'Finland',
  },
  {
    label: 'register.step.address.country.france',
    value: 'France',
  },
  {
    label: 'register.step.address.country.frenchguiana',
    value: 'French Guiana',
  },
  {
    label: 'register.step.address.country.frenchpolynesia',
    value: 'French Polynesia',
  },
  {
    label: 'register.step.address.country.gabon',
    value: 'Gabon',
  },
  {
    label: 'register.step.address.country.gambia',
    value: 'Gambia',
  },
  {
    label: 'register.step.address.country.georgia',
    value: 'Georgia',
  },
  {
    label: 'register.step.address.country.germany',
    value: 'Germany',
  },
  {
    label: 'register.step.address.country.ghana',
    value: 'Ghana',
  },
  {
    label: 'register.step.address.country.gibraltar',
    value: 'Gibraltar',
  },
  {
    label: 'register.step.address.country.greece',
    value: 'Greece',
  },
  {
    label: 'register.step.address.country.greenland',
    value: 'Greenland',
  },
  {
    label: 'register.step.address.country.grenada',
    value: 'Grenada',
  },
  {
    label: 'register.step.address.country.guadeloupe',
    value: 'Guadeloupe',
  },
  {
    label: 'register.step.address.country.guam',
    value: 'Guam',
  },
  {
    label: 'register.step.address.country.guatemala',
    value: 'Guatemala',
  },
  {
    label: 'register.step.address.country.guernsey',
    value: 'Guernsey',
  },
  {
    label: 'register.step.address.country.guinea',
    value: 'Guinea',
  },
  {
    label: 'register.step.address.country.guineabissau',
    value: 'Guinea‑Bissau',
  },
  {
    label: 'register.step.address.country.guyana',
    value: 'Guyana',
  },
  {
    label: 'register.step.address.country.haiti',
    value: 'Haiti',
  },
  {
    label: 'register.step.address.country.honduras',
    value: 'Honduras',
  },
  {
    label: 'register.step.address.country.hongkong',
    value: 'Hong Kong',
  },
  {
    label: 'register.step.address.country.hungary',
    value: 'Hungary',
  },
  {
    label: 'register.step.address.country.iceland',
    value: 'Iceland',
  },
  {
    label: 'register.step.address.country.india',
    value: 'India',
  },
  {
    label: 'register.step.address.country.indonesia',
    value: 'Indonesia',
  },
  {
    label: 'register.step.address.country.iran',
    value: 'Iran',
  },
  {
    label: 'register.step.address.country.iraq',
    value: 'Iraq',
  },
  {
    label: 'register.step.address.country.ireland',
    value: 'Ireland',
  },
  {
    label: 'register.step.address.country.isleofman',
    value: 'Isle of Man',
  },
  {
    label: 'register.step.address.country.israel',
    value: 'Israel',
  },
  {
    label: 'register.step.address.country.italy',
    value: 'Italy',
  },
  {
    label: 'register.step.address.country.jamaica',
    value: 'Jamaica',
  },
  {
    label: 'register.step.address.country.japan',
    value: 'Japan',
  },
  {
    label: 'register.step.address.country.jersey',
    value: 'Jersey',
  },
  {
    label: 'register.step.address.country.jordan',
    value: 'Jordan',
  },
  {
    label: 'register.step.address.country.kazakhstan',
    value: 'Kazakhstan',
  },
  {
    label: 'register.step.address.country.kenya',
    value: 'Kenya',
  },
  {
    label: 'register.step.address.country.kiribati',
    value: 'Kiribati',
  },
  {
    label: 'register.step.address.country.northkorea',
    value: 'North Korea',
  },
  {
    label: 'register.step.address.country.southkorea',
    value: 'South Korea',
  },
  {
    label: 'register.step.address.country.kuwait',
    value: 'Kuwait',
  },
  {
    label: 'register.step.address.country.kyrgyzstan',
    value: 'Kyrgyzstan',
  },
  {
    label: 'register.step.address.country.laos',
    value: 'Laos',
  },
  {
    label: 'register.step.address.country.latvia',
    value: 'Latvia',
  },
  {
    label: 'register.step.address.country.lebanon',
    value: 'Lebanon',
  },
  {
    label: 'register.step.address.country.lesotho',
    value: 'Lesotho',
  },
  {
    label: 'register.step.address.country.liberia',
    value: 'Liberia',
  },
  {
    label: 'register.step.address.country.libya',
    value: 'Libya',
  },
  {
    label: 'register.step.address.country.liechtenstein',
    value: 'Liechtenstein',
  },
  {
    label: 'register.step.address.country.lithuania',
    value: 'Lithuania',
  },
  {
    label: 'register.step.address.country.luxembourg',
    value: 'Luxembourg',
  },
  {
    label: 'register.step.address.country.macao',
    value: 'Macao',
  },
  {
    label: 'register.step.address.country.madagascar',
    value: 'Madagascar',
  },
  {
    label: 'register.step.address.country.malawi',
    value: 'Malawi',
  },
  {
    label: 'register.step.address.country.malaysia',
    value: 'Malaysia',
  },
  {
    label: 'register.step.address.country.maldives',
    value: 'Maldives',
  },
  {
    label: 'register.step.address.country.mali',
    value: 'Mali',
  },
  {
    label: 'register.step.address.country.malta',
    value: 'Malta',
  },
  {
    label: 'register.step.address.country.marshallislands',
    value: 'Marshall Islands',
  },
  {
    label: 'register.step.address.country.martinique',
    value: 'Martinique',
  },
  {
    label: 'register.step.address.country.mauritania',
    value: 'Mauritania',
  },
  {
    label: 'register.step.address.country.mauritius',
    value: 'Mauritius',
  },
  {
    label: 'register.step.address.country.mayotte',
    value: 'Mayotte',
  },
  {
    label: 'register.step.address.country.micronesia',
    value: 'Micronesia',
  },
  {
    label: 'register.step.address.country.moldova',
    value: 'Moldova',
  },
  {
    label: 'register.step.address.country.monaco',
    value: 'Monaco',
  },
  {
    label: 'register.step.address.country.mongolia',
    value: 'Mongolia',
  },
  {
    label: 'register.step.address.country.montenegro',
    value: 'Montenegro',
  },
  {
    label: 'register.step.address.country.montserrat',
    value: 'Montserrat',
  },
  {
    label: 'register.step.address.country.morocco',
    value: 'Morocco',
  },
  {
    label: 'register.step.address.country.mozambique',
    value: 'Mozambique',
  },
  {
    label: 'register.step.address.country.myanmar',
    value: 'Myanmar',
  },
  {
    label: 'register.step.address.country.namibia',
    value: 'Namibia',
  },
  {
    label: 'register.step.address.country.nauru',
    value: 'Nauru',
  },
  {
    label: 'register.step.address.country.nepal',
    value: 'Nepal',
  },
  {
    label: 'register.step.address.country.netherlands',
    value: 'Netherlands',
  },
  {
    label: 'register.step.address.country.newcaledonia',
    value: 'New Caledonia',
  },
  {
    label: 'register.step.address.country.newzealand',
    value: 'New Zealand',
  },
  {
    label: 'register.step.address.country.nicaragua',
    value: 'Nicaragua',
  },
  {
    label: 'register.step.address.country.niger',
    value: 'Niger',
  },
  {
    label: 'register.step.address.country.nigeria',
    value: 'Nigeria',
  },
  {
    label: 'register.step.address.country.niue',
    value: 'Niue',
  },
  {
    label: 'register.step.address.country.northmacedonia',
    value: 'North Macedonia',
  },
  {
    label: 'register.step.address.country.northernmarianaislands',
    value: 'Northern Mariana Islands',
  },
  {
    label: 'register.step.address.country.norway',
    value: 'Norway',
  },
  {
    label: 'register.step.address.country.oman',
    value: 'Oman',
  },
  {
    label: 'register.step.address.country.pakistan',
    value: 'Pakistan',
  },
  {
    label: 'register.step.address.country.palau',
    value: 'Palau',
  },
  {
    label: 'register.step.address.country.panama',
    value: 'Panama',
  },
  {
    label: 'register.step.address.country.papuanewguinea',
    value: 'Papua New Guinea',
  },
  {
    label: 'register.step.address.country.paraguay',
    value: 'Paraguay',
  },
  {
    label: 'register.step.address.country.peru',
    value: 'Peru',
  },
  {
    label: 'register.step.address.country.philippines',
    value: 'Philippines',
  },
  {
    label: 'register.step.address.country.poland',
    value: 'Poland',
  },
  {
    label: 'register.step.address.country.portugal',
    value: 'Portugal',
  },
  {
    label: 'register.step.address.country.qatar',
    value: 'Qatar',
  },
  {
    label: 'register.step.address.country.reunion',
    value: 'Réunion',
  },
  {
    label: 'register.step.address.country.romania',
    value: 'Romania',
  },
  {
    label: 'register.step.address.country.russia',
    value: 'Russia',
  },
  {
    label: 'register.step.address.country.rwanda',
    value: 'Rwanda',
  },
  {
    label: 'register.step.address.country.saintbarthelemy',
    value: 'Saint Barthélemy',
  },
  {
    label: 'register.step.address.country.sainthelenaascensionandtristandacunha',
    value: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    label: 'register.step.address.country.saintkittsannevis',
    value: 'Saint Kitts and Nevis',
  },
  {
    label: 'register.step.address.country.saintlucia',
    value: 'Saint Lucia',
  },
  {
    label: 'register.step.address.country.saintmartin',
    value: 'Saint Martin',
  },
  {
    label: 'register.step.address.country.saintpierreandmiquelon',
    value: 'Saint Pierre and Miquelon',
  },
  {
    label: 'register.step.address.country.saintvincentandthegrenadines',
    value: 'Saint Vincent and the Grenadines',
  },
  {
    label: 'register.step.address.country.samoa',
    value: 'Samoa',
  },
  {
    label: 'register.step.address.country.sanmarino',
    value: 'San Marino',
  },
  {
    label: 'register.step.address.country.saotomeandprincipe',
    value: 'Sao Tome and Principe',
  },
  {
    label: 'register.step.address.country.saudiarabia',
    value: 'Saudi Arabia',
  },
  {
    label: 'register.step.address.country.senegal',
    value: 'Senegal',
  },
  {
    label: 'register.step.address.country.serbia',
    value: 'Serbia',
  },
  {
    label: 'register.step.address.country.seychelles',
    value: 'Seychelles',
  },
  {
    label: 'register.step.address.country.sierraleone',
    value: 'Sierra Leone',
  },
  {
    label: 'register.step.address.country.singapore',
    value: 'Singapore',
  },
  {
    label: 'register.step.address.country.sintmaarten',
    value: 'Sint Maarten',
  },
  {
    label: 'register.step.address.country.slovakia',
    value: 'Slovakia',
  },
  {
    label: 'register.step.address.country.slovenia',
    value: 'Slovenia',
  },
  {
    label: 'register.step.address.country.solomonislands',
    value: 'Solomon Islands',
  },
  {
    label: 'register.step.address.country.somalia',
    value: 'Somalia',
  },
  {
    label: 'register.step.address.country.southafrica',
    value: 'South Africa',
  },
  {
    label: 'register.step.address.country.southsudan',
    value: 'South Sudan',
  },
  {
    label: 'register.step.address.country.spain',
    value: 'Spain',
  },
  {
    label: 'register.step.address.country.srilanka',
    value: 'Sri Lanka',
  },
  {
    label: 'register.step.address.country.sudan',
    value: 'Sudan',
  },
  {
    label: 'register.step.address.country.suriname',
    value: 'Suriname',
  },
  {
    label: 'register.step.address.country.sweden',
    value: 'Sweden',
  },
  {
    label: 'register.step.address.country.switzerland',
    value: 'Switzerland',
  },
  {
    label: 'register.step.address.country.syria',
    value: 'Syria',
  },
  {
    label: 'register.step.address.country.taiwan',
    value: 'Taiwan',
  },
  {
    label: 'register.step.address.country.tajikistan',
    value: 'Tajikistan',
  },
  {
    label: 'register.step.address.country.tanzania',
    value: 'Tanzania',
  },
  {
    label: 'register.step.address.country.thailand',
    value: 'Thailand',
  },
  {
    label: 'register.step.address.country.timorleste',
    value: 'Timor‑Leste',
  },
  {
    label: 'register.step.address.country.togo',
    value: 'Togo',
  },
  {
    label: 'register.step.address.country.tonga',
    value: 'Tonga',
  },
  {
    label: 'register.step.address.country.trinidadandtobago',
    value: 'Trinidad and Tobago',
  },
  {
    label: 'register.step.address.country.tunisia',
    value: 'Tunisia',
  },
  {
    label: 'register.step.address.country.turkiye',
    value: 'Türkiye',
  },
  {
    label: 'register.step.address.country.turkmenistan',
    value: 'Turkmenistan',
  },
  {
    label: 'register.step.address.country.turksandcaicoislands',
    value: 'Turks and Caicos Islands',
  },
  {
    label: 'register.step.address.country.tuvalu',
    value: 'Tuvalu',
  },
  {
    label: 'register.step.address.country.uganda',
    value: 'Uganda',
  },
  {
    label: 'register.step.address.country.ukraine',
    value: 'Ukraine',
  },
  {
    label: 'register.step.address.country.unitedarabemirates',
    value: 'United Arab Emirates',
  },
  {
    label: 'register.step.address.country.unitedkingdom',
    value: 'United Kingdom',
  },
  {
    label: 'register.step.address.country.uruguay',
    value: 'Uruguay',
  },
  {
    label: 'register.step.address.country.uzbekistan',
    value: 'Uzbekistan',
  },
  {
    label: 'register.step.address.country.vanuatu',
    value: 'Vanuatu',
  },
  {
    label: 'register.step.address.country.venezuela',
    value: 'Venezuela',
  },
  {
    label: 'register.step.address.country.vietnam',
    value: 'Vietnam',
  },
  {
    label: 'register.step.address.country.britishvirginislands',
    value: 'British Virgin Islands',
  },
  {
    label: 'register.step.address.country.usvirginislands',
    value: 'US Virgin Islands',
  },
  {
    label: 'register.step.address.country.wallisandfutuna',
    value: 'Wallis and Futuna',
  },
  {
    label: 'register.step.address.country.yemen',
    value: 'Yemen',
  },
  {
    label: 'register.step.address.country.zambia',
    value: 'Zambia',
  },
  {
    label: 'register.step.address.country.zimbabwe',
    value: 'Zimbabwe',
  },
]

export const REGISTER_FORM_ADDRESS_COUNTRIES_COMBINED = [
  ...REGISTER_FORM_ADDRESS_COUNTRIES_MOST_USED,
  ...REGISTER_FORM_ADDRESS_COUNTRIES.sort((a, b) => a.label.localeCompare(b.label)),
  {
    label: 'register.step.address.country.other',
    value: 'Other',
  },
]

export const REGISTER_FORM_ADDRESS_COUNTRIES_OPTIONS = REGISTER_FORM_ADDRESS_COUNTRIES_COMBINED.map(
  (country) => ({
    label: country.label,
    value: country.value,
  }),
)

export const REGISTER_FORM_ADDRESS_STATES = [
  { long: 'licensedterritory.usal', short: 'AL' },
  { long: 'licensedterritory.usak', short: 'AK' },
  { long: 'licensedterritory.usaz', short: 'AZ' },
  { long: 'licensedterritory.usar', short: 'AR' },
  { long: 'licensedterritory.usca', short: 'CA' },
  { long: 'licensedterritory.usco', short: 'CO' },
  { long: 'licensedterritory.usct', short: 'CT' },
  { long: 'licensedterritory.usde', short: 'DE' },
  { long: 'licensedterritory.usfl', short: 'FL' },
  { long: 'licensedterritory.usga', short: 'GA' },
  { long: 'licensedterritory.ushi', short: 'HI' },
  { long: 'licensedterritory.usid', short: 'ID' },
  { long: 'licensedterritory.usil', short: 'IL' },
  { long: 'licensedterritory.usin', short: 'IN' },
  { long: 'licensedterritory.usia', short: 'IA' },
  { long: 'licensedterritory.usks', short: 'KS' },
  { long: 'licensedterritory.usky', short: 'KY' },
  { long: 'licensedterritory.usla', short: 'LA' },
  { long: 'licensedterritory.usme', short: 'ME' },
  { long: 'licensedterritory.usmd', short: 'MD' },
  { long: 'licensedterritory.usma', short: 'MA' },
  { long: 'licensedterritory.usmi', short: 'MI' },
  { long: 'licensedterritory.usmn', short: 'MN' },
  { long: 'licensedterritory.usms', short: 'MS' },
  { long: 'licensedterritory.usmo', short: 'MO' },
  { long: 'licensedterritory.usmt', short: 'MT' },
  { long: 'licensedterritory.usne', short: 'NE' },
  { long: 'licensedterritory.usnv', short: 'NV' },
  { long: 'licensedterritory.usnh', short: 'NH' },
  { long: 'licensedterritory.usnj', short: 'NJ' },
  { long: 'licensedterritory.usnm', short: 'NM' },
  { long: 'licensedterritory.usny', short: 'NY' },
  { long: 'licensedterritory.usnc', short: 'NC' },
  { long: 'licensedterritory.usnd', short: 'ND' },
  { long: 'licensedterritory.usoh', short: 'OH' },
  { long: 'licensedterritory.usok', short: 'OK' },
  { long: 'licensedterritory.usor', short: 'OR' },
  { long: 'licensedterritory.uspa', short: 'PA' },
  { long: 'licensedterritory.usri', short: 'RI' },
  { long: 'licensedterritory.ussc', short: 'SC' },
  { long: 'licensedterritory.ussd', short: 'SD' },
  { long: 'licensedterritory.ustn', short: 'TN' },
  { long: 'licensedterritory.ustx', short: 'TX' },
  { long: 'licensedterritory.usut', short: 'UT' },
  { long: 'licensedterritory.usvt', short: 'VT' },
  { long: 'licensedterritory.usva', short: 'VA' },
  { long: 'licensedterritory.uswa', short: 'WA' },
  { long: 'licensedterritory.uswv', short: 'WV' },
  { long: 'licensedterritory.uswi', short: 'WI' },
  { long: 'licensedterritory.uswy', short: 'WY' },
] as const

export const REGISTER_FORM_IDS = {
  Account: 'account',
  Address: 'address',
  Name: 'name',
  PersonalData: 'personalData',
} as const

export const REGISTER_FORM_NAME = {
  FamilyName: 'familyName',
  GivenName: 'givenName',
} as const

export const REGISTER_FORM_PERSONAL_DATA = {
  CountryCode: 'countryCode',
  DateOfBirth: 'dateOfBirth',
  PhoneNumber: 'phoneNumber',
} as const

export type RegisterFormId = ObjectValues<typeof REGISTER_FORM_IDS>

export type RegisterStep = {
  icon: LcIconName
  id: RegisterFormId
  progress: { max: number; min: number }
  route: string
}

export const REGISTER_CONFIG: readonly RegisterStep[] = [
  {
    icon: 'profile-person',
    id: REGISTER_FORM_IDS.Name,
    progress: { max: 25, min: 0 },
    route: '/register/name',
  },
  {
    icon: 'phone-call',
    id: REGISTER_FORM_IDS.PersonalData,
    progress: { max: 50, min: 25 },
    route: '/register/personaldata',
  },
  {
    icon: 'location',
    id: REGISTER_FORM_IDS.Address,
    progress: { max: 75, min: 50 },
    route: '/register/address',
  },
  {
    icon: 'lock',
    id: REGISTER_FORM_IDS.Account,
    progress: { max: 100, min: 75 },
    route: '/register/account',
  },
] as const

export const REGISTER_FORM_INITIAL_VALUES = {
  [REGISTER_FORM_ADDRESS.Country]: REGISTER_FORM_ADDRESS_COUNTRIES_UNITED_STATES,
  [REGISTER_FORM_ADDRESS.State]: 'CO',
  [REGISTER_FORM_ADDRESS.StateLong]: 'Colorado',
} as const
